import "./darkLoader.css";

const DarkLoader = () => {
	return (
		<div className="dark-loader-container">
			<div className="dark-loader"></div>
		</div>
	);
};

export default DarkLoader;
